import { render, staticRenderFns } from "./MunicipalityEdit.vue?vue&type=template&id=3e3eb951&scoped=true&"
import script from "./MunicipalityEdit.vue?vue&type=script&lang=js&"
export * from "./MunicipalityEdit.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityEdit.vue?vue&type=style&index=0&id=3e3eb951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3eb951",
  null
  
)

export default component.exports